<template>

    <h3>Доставка:</h3>

    <p>
      1. Курьерская доставка по Москве и Московской области – 290 ₽<br>
      2.Самовывоз из магазина. Список и адреса магазинов Вы можете посмотреть здесь<br>
    </p>

    <h3>Возврат:</h3>

    <p>
      Любой возврат должен быть осуществлен в течение Возвраты в магазине БЕСПЛАТНО.<br>
      Вы можете вернуть товары в любой магазин. Магазин должен быть расположен в стране,
       в
      которой Вы осуществили покупку.
      БЕСПЛАТНЫЙ возврат в Пункт выдачи заказов.<br>
      Для того чтобы вернуть товар в одном из наших Пунктов выдачи заказов, позвоните по
      телефону
      8 800 600 90 09<br>
    </p>
</template>
<script>
export default {
};
</script>
